import React, { Component } from 'react';
import { Grid, Card, Toolbar, CardContent, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { ErrorOutline as LoadErrorIcon } from '@mui/icons-material';
import Config from '../../config';
import axios from 'axios';
import ContentLoader from '../../components/content_loader';
import Moment from 'react-moment';
import Helpers, { formatCurrency } from '../../helpers';
import Status from '../../components/status';
import { FakeField } from '../../components/text_field';

const invoiceStatusColors: Record<string, string> = {
    "Paid": "#448044",
    "Void": "#AAA",
    "Overdue": "#ee3224"
};

interface InvoiceItem {
    Description?: string;
    Quantity?: number;
    Price?: number;
    Discount?: number;
}

interface Invoice {
    Id?: string | number;
    Number?: string;
    Status?: string;
    Currency?: string;
    InvoiceDate?: string;
    DueDate?: string;
    SubTotal?: number;
    Discount?: number;
    Total?: number;
    Balance?: number;
    Items?: InvoiceItem[];
}

interface InvoiceStatusProps {
    status?: string;
}

class InvoiceStatus extends Component<InvoiceStatusProps> {
    render(){
        let {status} = this.props;
        let color = invoiceStatusColors[status as string];
        return <Status color={color} description={status}/>;
    }
}

interface SubscriptionInvoiceDetailState {
    loaded: boolean;
    invoice: Invoice;
    showError: boolean;
    loadError?: boolean;
}

class SubscriptionInvoiceDetail extends Component<{}, SubscriptionInvoiceDetailState> {
    state: SubscriptionInvoiceDetailState = {loaded: false, invoice: {}, showError: false};
    async componentDidMount(){
        let invoiceId = new Helpers().queryString()['id'];
        try{
            var invoice: Invoice = (await axios.get(Config.api + `/odata/Company/Invoices('${invoiceId}')`)).data;
            this.setState({invoice: invoice, loaded: true});
        }catch{
            this.setState({loadError: true, loaded: true});
        }
    }
    render(){
        if(this.state.loadError){
            return <Grid container spacing={2}>
                <Grid size={12}>
                  <LoadErrorIcon style={{fontSize: '14rem', color: '#999'}}/>
                </Grid>
                <Grid size={12} style={{fontSize: '1.5rem', color: '#999'}}>{'Sorry, we could not load that invoice for you.'}</Grid>
          </Grid>;
        }
        if(!this.state.loaded){
            return <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '6em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '20em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '20em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
            </Grid>;
        }
        return <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                <Card>
                    <Toolbar className='lbdocbar'>Invoice {this.state.invoice.Number}</Toolbar>
                    <Toolbar className='lbstatusbar' style={{backgroundColor: invoiceStatusColors[this.state.invoice.Status as string] || "#FFA500"}}>Status: {this.state.invoice.Status}</Toolbar>
                </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }} style={{display: 'flex'}}>
                <Card style={{flex: 1}}>
                    <Toolbar className='lbtoolbar'>General Information</Toolbar>
                    <CardContent style={{display: 'flex', flexDirection: 'column'}}>
                        <FakeField label='Invoice number'>{this.state.invoice.Number}</FakeField>
                        <FakeField label='Invoice date'>{<Moment format='MM/DD/YYYY'>{this.state.invoice.InvoiceDate}</Moment>}</FakeField>
                        <FakeField label='Due date'>{<Moment format='MM/DD/YYYY'>{this.state.invoice.DueDate}</Moment>}</FakeField>
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Card>
                    <Toolbar className='lbtoolbar'>Totals</Toolbar>
                    <CardContent style={{display: 'flex', flexDirection: 'column'}}>
                        <FakeField label='Subtotal'>{formatCurrency(this.state.invoice.SubTotal, this.state.invoice.Currency)}</FakeField>
                        <FakeField label='Credits and coupons'>{formatCurrency(this.state.invoice.Discount, this.state.invoice.Currency)}</FakeField>
                        <FakeField label='Total'>{formatCurrency(this.state.invoice.Total, this.state.invoice.Currency)}</FakeField>
                        <FakeField label='Balance'>{formatCurrency(this.state.invoice.Balance, this.state.invoice.Currency)}</FakeField>
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={12}>
            <Card>
            <Toolbar className='lbtoolbar'>Line Items</Toolbar>
                <Table className='itemTable'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Description</TableCell>
                            <TableCell style={{width: '9em'}}>Quantity</TableCell>
                            <TableCell style={{width: '9em'}}>Price</TableCell>
                            <TableCell style={{width: '9em'}}>Discount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(this.state.invoice.Items || []).map((r, i) => <TableRow key={i}>
                            <TableCell>{r.Description}</TableCell>
                            <TableCell>{r.Quantity}</TableCell>
                            <TableCell>{formatCurrency(r.Price, this.state.invoice.Currency)}</TableCell>
                            <TableCell>{formatCurrency(r.Discount, this.state.invoice.Currency)}</TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
                </Card>
            </Grid>
        </Grid>;
    }
}

export default SubscriptionInvoiceDetail;

export { InvoiceStatus };
export type { Invoice, InvoiceItem };
